import React, { useState } from 'react';
import {
  Card,
  Col,
  Form,
  Row,
} from 'react-bootstrap';

function Input({ answer, scores, isReadonly }) {

  const [attachment, setAttachment] = useState(answer?.answerAttachments?.pop() ?? null);

  return (
    <Row>
      <Col md="12">
        <Card>
          <Card.Header>
            <Card.Title style={{fontWeight:'bold', fontSize:'20px', marginBottom:10}} as="h5">{answer.question.QUESTION_CODE}. <a style={{fontWeight:'bold'}} dangerouslySetInnerHTML={{__html: answer.question.QUESTION_LABEL}} /></Card.Title>
            <div style={{whiteSpace: 'pre-wrap', marginLeft:18, marginTop:5, fontSize:'17px'}} dangerouslySetInnerHTML={{__html: answer.question.QUESTION_DESC}} />
            <hr></hr>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md="10">
                <Form.Group>
                  <Form.Label style={{fontSize:'17px'}}>Auditee's Answer</Form.Label>
                  <p>{answer.ANSWER_DESC ?? (
                    <span class="text-danger">Not answered yet.</span>
                  )}</p>
                </Form.Group>
                <Form.Group>
                  <Form.Label style={{fontSize:'17px'}}>Auditor's Evaluation</Form.Label>
                  <p>{answer.EVALUATE_DESC ?? (
                      <span class="text-warning">Not evaluated yet.</span>
                  )}</p>
                </Form.Group>
              </Col>
              <Col md="2">
                <Form.Group>
                  {attachment?.ATTACHMENT_ID ? (
                    <a
                      href={`${process.env.REACT_APP_API_HOST}answer-attachments/${attachment.ATTACHMENT_ID}/download`}
                      className="btn btn-info"
                    >
                      Download
                    </a>
                  ) : (<p>No attachment uploaded.</p>)}
                </Form.Group>
                <Form.Group>
                  <Form.Label>Score</Form.Label>
                  <p>{scores.find(item => item.INDEX_ID === answer.INDEX_ID)?.SCORE_INDEX ?? (
                    <span class="text-warning">Not scored yet.</span>
                  )}</p>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}

export default Input;